export class ListAggregationServingTokensRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListAggregationServingTokensFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortAggregationServingTokenBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAggregationServingTokensRequest.attributeTypeMap;
    }
    constructor() {
    }
}
